import { Button, Modal } from 'react-bootstrap';

export const AgreementConfirmation = ({
  show,
  onHide,
}: {
  show: boolean;
  onHide: (accepted: boolean) => void;
}) => {
  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>Accept Agreement</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        To continue adjust availability you need to sign and accept agreement.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={() => onHide(false)}>
          Complete Later
        </Button>
        <Button variant="primary" onClick={() => onHide(true)}>
          Go to Agreement
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
